import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("regency_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const api = {
  login: (email, password) => client.post("/auth/login", { email, password }),
  me: () => client.get("/auth/me"),
  listPosts: (params = {}) => client.get("/posts", { params }),
  getPost: (slug) => client.get(`/posts/${slug}`),
  categories: () => client.get("/categories"),
  adminPosts: () => client.get("/admin/posts"),
  createPost: (data) => client.post("/admin/posts", data),
  updatePost: (id, data) => client.put(`/admin/posts/${id}`, data),
  deletePost: (id) => client.delete(`/admin/posts/${id}`),
  uploadImage: (formData) =>
    client.post("/admin/upload", formData, { headers: { "Content-Type": "multipart/form-data" } }),
};

export default client;
